import wgsl from "refractor/wgsl";
export default wgsl;